/** Imperative toast + confirm/prompt dialogs (replaces window.alert / confirm / prompt).
 * Prefer calling modernAlert / modernConfirm / modernPrompt directly.
 * When ModernDialogHost is mounted it also patches window.alert/confirm/prompt.
 */

export const MODERN_ALERT_EVENT = "enterprise-modern-alert";
export const MODERN_CONFIRM_EVENT = "enterprise-modern-confirm";
export const MODERN_PROMPT_EVENT = "enterprise-modern-prompt";

export function modernAlert(message) {
  window.dispatchEvent(
    new CustomEvent(MODERN_ALERT_EVENT, {
      detail: { message: String(message ?? "") },
    }),
  );
}

/**
 * @param {string} message
 * @param {{ title?: string, confirmLabel?: string, cancelLabel?: string, danger?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export function modernConfirm(message, options = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent(MODERN_CONFIRM_EVENT, {
        detail: {
          message: String(message ?? ""),
          title: options.title,
          confirmLabel: options.confirmLabel,
          cancelLabel: options.cancelLabel,
          danger: Boolean(options.danger),
          resolve,
        },
      }),
    );
  });
}

/**
 * @param {string} message
 * @param {{ title?: string, defaultValue?: string, confirmLabel?: string, cancelLabel?: string }} [options]
 * @returns {Promise<string|null>}
 */
export function modernPrompt(message, options = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent(MODERN_PROMPT_EVENT, {
        detail: {
          message: String(message ?? ""),
          title: options.title,
          defaultValue: String(options.defaultValue ?? ""),
          confirmLabel: options.confirmLabel,
          cancelLabel: options.cancelLabel,
          resolve,
        },
      }),
    );
  });
}
